import logo from "../postgres/logo.svg";
import {
  postgresConnectionFields,
  postgresConnectionString,
} from "../postgres/shared";
import { rdsIamFields, rdsIamSteps } from "../rdsIam";
import { awsRdsIamAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";

export const awsRdsPostgres = defineConnector({
  identifier: "awsRdsPostgres",
  name: "AWS RDS Postgres",
  tagLine: "Connect to RDS or Aurora PostgreSQL with IAM",
  logo,
  tags: ["data"],
  protocol: "postgres",
  connectionTest: {
    protocol: "postgres",
    connectionString: (configuration) =>
      postgresConnectionString(configuration, true),
  },
  defaultUrlPattern: () => "",
  customizeStepHandledInline: true,
  auth: (app) =>
    awsRdsIamAuth({
      roleArn: app.config.roleArn,
      issuer: app.issuer ?? "",
      host: app.config.host,
      port: app.config.port,
      username: app.config.username,
      region: app.config.region,
    }),
  steps: [
    {
      title: "Enter your RDS Postgres connection",
      items: [
        {
          kind: "input",
          label: "Name",
          required: true,
          defaultValue: "AWS RDS Postgres",
          target: { kind: "connectedApp", field: "name" },
        },
        ...postgresConnectionFields,
        ...rdsIamFields,
        {
          kind: "file",
          label: "CA certificate",
          accept: ".pem,.crt,.cer",
          helperText:
            "Optional PEM CA certificate. RDS IAM connections always use TLS.",
          target: { kind: "configuration", field: "tlsCaCertificate" },
        },
      ],
    },
    ...rdsIamSteps,
  ],
  publicEnvVars: (configuration) => ({
    POSTGRES_URL: postgresConnectionString(configuration, true),
  }),
  usageHint: () =>
    "Use process.env.POSTGRES_URL as the Postgres connection string.",
});
